<template>
  <div role="article" class="izbl-part" :data-jest-part="part.id">
    <div
      class="document-container part-title has-content"
      :class="[stateClasses]"    
    >
      <div class="symbol" :class="icon" @click="toggleChildren">
        <div class="icon-wrapper">
          <font-awesome-icon icon="plus" v-if="(!showChildren && !inShare)" />
          <font-awesome-icon icon="minus" v-if="(showChildren || inShare)" />
        </div>
      </div>
      <div class="text" @click="toggleChildren">
        {{ part.version }} 
        <span v-html="part.title"></span> 
        <span class="control-cmd" @click.stop="expandAll" v-if="!allExpanded" title="See all the bylaws in this part"><font-awesome-icon icon="angle-double-down" /></span>
        <span class="control-cmd" @click.stop="collapseAll" v-if="allExpanded" title="Collapse this part">
          <font-awesome-icon icon="angle-double-up" /></span>
      </div>
      
    </div>
    <div class="document-body indent" v-if="part.description && (showChildren || inShare)">
        <div v-if="part.description" v-html="part.description"></div>
    </div>
    
    <div role="group" v-if="showChildren || inShare" class="document-content children">
      <ByLawContent
        v-for="part in subDocuments"
        :key="part.id + componentKey"
        :document="part"
        :subDocuments="part.subDocuments"
        :level="1"
        :propagate="propagate"
        @addToPrint="enqueuePrint"
      />
    </div>
  </div>
</template>


<script>
import ByLawContent from "@/components/ByLawContent";

import  "@/assets/sass/documentviewer.scss";
import {mapActions } from "vuex";

export default {
  name: "ByLawPart",
  components: {
    ByLawContent
  },
  props: {
    part: Object,   
    subDocuments: Array
  },
  data() {
    return {
      showChildren: false,
      componentKey : 1,
      propagate: false,
      allExpanded: false,
      printQueue: []
    };
  },
  mounted(){
    
  },
  computed: {
   
    icon() {
      return {
        plus: !this.showChildren,
        minus: this.showChildren
      };
    },       
    stateClasses() {
      return {
        collapsed: !this.showChildren,
        expanded: this.showChildren
      };
    },
    isLastLevel: function(){
      return this.subDocuments == null || this.subDocuments.length == 0;
    },
    inShare: function(){
      if(this.$route.name == "share"){
        var ids = this.$route.params.showItems.split(",");
        const index = ids.indexOf('p'+this.part.id.toString());
        const showAll = this.$route.params.showItems.indexOf(this.part.id.toString() + ",all");
        
        if(index >= 0){
          if(this.subDocuments == null){
           this.fetchPusblishedContentByPart(this.part.id);          
          }
          if(showAll > -1){
            this.propagate = true;
            this.allExpanded = true;
          }          
          this.showChildren = true;       
          this.$ga.page(`/show/${this.part.title}`);  
          return true;
        } 
        else{
          this.showChildren = false;
          return false;
        }
      }
      
    }
  },
  methods: {
    ...mapActions("viewer", ["fetchPusblishedContentByPart"]),
    enqueuePrint(id){ 
      if(this.printQueue.indexOf(id) < 0){
        this.printQueue.push(id);
      } else {
        this.printQueue.splice(this.printQueue.indexOf(id), 1);
      }
      this.$emit("notify");
    },   
    toggleChildren() {        
      if(this.subDocuments == null){
          this.fetchPusblishedContentByPart(this.part.id);          
      }

       if(this.$route.name == "share"){
  
          var ids = this.$route.params.showItems.split(",");          
          var routeChanged = false;         
          const index = ids.indexOf('p'+this.part.id.toString());
          
          if(index > -1){ 
            ids.splice(index,1);
            routeChanged = true;
          }
          else{
            if(!this.showChildren){
              this.$ga.page(`/show/${this.part.title}`);
              ids.push('p'+this.part.id);
              routeChanged = true;
            }
          }

          if(routeChanged){
            this.$router.replace({ name: "share", params: {showItems:ids.join(",")} })
          }
      }else{       
            this.$ga.page(`/show/${this.part.title}`);
            this.$router.push({path:`/show/p${this.part.id}`});        
      }      
      this.showChildren = !this.showChildren;     
    },
    collapseAll: function() {       
        this.propagate = false;
        this.componentKey = this.componentKey + Math.floor(Math.random() * 100);
        this.allExpanded = false;
        this.toggleChildren();
        this.showChildren = false;
    },
    expandAll: function() {       
        this.propagate = true;
        this.componentKey = this.componentKey + Math.floor(Math.random() * 100);
        this.allExpanded = true;
        this.toggleChildren();
        this.showChildren = true;

    }
  },
   watch: {
    '$route.query.reset': function (newvalue) {
      this.showChildren = false;
      this.propagate = false;
      this.printQueue = [];
    }
  }
};
</script>